const TRUST_EXPERIENCE_TABS_DATA = [
  {
    id: 'competitors',
    key: 'competitors',
    name: 'SUPERIOR QUALITY',
    nameMob: 'QUALITY',
    items: [
      {
        id: 1,
        type: '',
        url: '',
        title: 'Competitors',
        description: 'Big Box competitors may get the job "done" for less, but lack of dedication to quality equipment and qualified engineers shows in the finished product.',
      },
      {
        id: 2,
        type: '',
        url: '',
        title: 'Forever Classic',
        description: 'Forever Classic digitizing was developed with one goal in mind: to get you a better quality transfer than the competition for a family friendly price.',
      },
      {
        id: 3,
        type: '',
        url: '',
        title: 'Forever Gold',
        description: 'All Forever Gold digitizing is done at higher resolutions, with expanded color depth, and clarity enhancements only available at FS. There is nothing else like it.',
      },
    ],
    withButton: false,
    buttonText: '',
    onClick: () => {},
  },
  {
    id: 'process',
    key: 'process',
    name: 'CLOUD FEATURES',
    nameMob: 'CLOUD',
    items: [
      {
        id: 1,
        title: 'User Friendly',
        description: 'Forever Cloud was built with ease of use in mind, specifically to make enjoying your memories ultra accessible.',
        imageSrc: '',
      },
      {
        id: 2,
        title: 'Easy Sharing',
        description: 'Sharing your media memories with friends and family is just a click away with our built in sharing functions.',
        imageSrc: '',
      },
      {
        id: 3,
        title: 'Simple Organazing',
        description: 'Rename and organize every single piece of digital media in your cloud account, and personalize your media archive.',
        imageSrc: '',
      },
      {
        id: 4,
        title: 'Secure Storage',
        description: 'FAll Forever Cloud accounts are hosted on Amazon Web Services servers, with totally dependable safety & security.',
        imageSrc: '',
      },
    ],
    withButton: false,
    buttonText: '',
    onClick: () => {},
  },
  {
    id: 'products',
    key: 'products',
    name: 'POLISHED PRODUCTS',
    nameMob: 'PRODUCTS',
    title: 'Enjoy Your Memories Forever With Exclusive Products.',
    titleMob: 'Enjoy Your Memories Exclusive Products..',
    descriptions: [
      {
        id: '1',
        title: 'Premium USB Drives',
        text: 'Our USBs are high-speed USB 3.0 drives with premium archival-grade chipsets. Finished with a Forever Studios logo in a real bamboo case.',
      },
      {
        id: '2',
        title: 'Personalized USB Gift Boxes',
        text: 'Looking for an elegant way to give your digitized family memories to a loved one? Our personalized real bamboo USB Gift Boxes are the perfect choice.',
      },
      {
        id: '3',
        title: 'Slideshows & Printing',
        text: 'We are the only provider that offers special multimedia & printing services like video editing, slideshows, and ultra-premium photo printing.',
      },
    ],
    imageSrc: '',
    isLeft: true,
    linkUrl: '#',
    linkText: 'Visit Our Forever Care Support Center',
    withLink: false,
    withButton: false,
    buttonText: '',
    onClick: () => {},
  },
  {
    id: 'support',
    key: 'support',
    name: 'ALWAYS AVAILABLE',
    nameMob: 'AVAILABILITY',
    title: 'You\'re Never Out of the Loop With Forever Care.',
    titleMob: 'What\'s Forever Care Support?',
    descriptions: [
      {
        id: '1',
        title: 'Live Ordering Assistance',
        text: 'Access real people who can help you make educated choices for your digitizing project, on demand. There are never any barriers to getting the answers you need, wait times, or other annoying things like being forced to have a \'conversation\' with a robot.',
      },
      {
        id: '2',
        title: 'Forever Care Support',
        text: 'Our mission to provide the best quality experience does not end with making a sale or shipping your memories back. We\'re well known for having the best support services in the industry, with a huge online knowledge base, phone support, and a no-excuses guarantee.',
      },
    ],
    imageSrc: '',
    isLeft: false,
    linkUrl: '#',
    linkText: 'Visit Our Forever Care Support Center',
    withLink: true,
    withButton: false,
    buttonText: '',
    onClick: () => {},
  },
];

const TRUST_EXPERIENCE_TITLE_LIST_DATA = [
  {
    id: 1,
    text: '',
    textMob: '',
    secondText: 'A Uniquely Special Experience',
    secondTextMob: 'a uniquely special',
    isTextReverse: false,
    isTextReverseMob: false,
    isTextColumn: false,
    isTextColumnMob: false,
    isLeft: true,
    isLeftMob: true,
    isRight: false,
    isRightMob: false,
    color: '#000',
    colorMob: '#000',
    isTextWithLine: false,
    isTextWithLineMob: false,
    isSecondTextWithLine: true,
    isSecondTextWithLineMob: true,
    firstTextLines: [],
    secondTextLines: [{
      id: 1,
      isLeftLine: false,
      isRightLine: true,
      isTopLine: false,
      isBottomLine: false,
      color: '#000',
      isLineWithSquare: true,
      isLeftLineMob: false,
      isRightLineMob: true,
      isTopLineMob: false,
      isBottomLineMob: false,
      colorMob: '#000',
      isLineWithSquareMob: true,
    }],
  },
  {
    id: 1,
    text: 'in All The Ways That Matter.',
    textMob: 'experience.',
    secondText: '',
    secondTextMob: '',
    isTextReverse: false,
    isTextReverseMob: false,
    isTextColumn: false,
    isTextColumnMob: false,
    isLeft: false,
    isLeftMob: true,
    isRight: true,
    isRightMob: false,
    color: '#000',
    colorMob: '#000',
    isTextWithLine: true,
    isTextWithLineMob: false,
    isSecondTextWithLine: false,
    isSecondTextWithLineMob: false,
    firstTextLines: [{
      id: 1,
      isLeftLine: true,
      isRightLine: false,
      isTopLine: false,
      isBottomLine: false,
      color: '#000',
      isLineWithSquare: false,
      isLeftLineMob: false,
      isRightLineMob: true,
      isTopLineMob: false,
      isBottomLineMob: false,
      colorMob: '#5F8AA4',
      isLineWithSquareMob: true,
    }],
    secondTextLines: [],
  },
];

export {
  TRUST_EXPERIENCE_TABS_DATA,
  TRUST_EXPERIENCE_TITLE_LIST_DATA,
};
